module.exports = __webpack_public_path__ + "static/img/worry-1.5e94fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/worry-1.png
// module id = bsEu
// module chunks = 1